export default "__VITE_IMAGE_ASSET__6880b1f7__";